let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("al8If")).then(() => parcelRequire('khTCh'));